import { useAuthStore } from '@/stores/auth';
import { useLocaleStore } from '@/stores/locales';

export const AMBASSADOR = {
  path: 'ambassador',
  redirect: () =>
    useAuthStore().getFullUser.user_data?.is_ambassador
      ? { name: 'ambassador-portal' }
      : { name: 'ambassador-subscription' },
  // Ambassador feature is only available for French recruiters with hubspot_id
  beforeEnter: () => {
    if (useLocaleStore().getCurrentISO !== 'fr-FR' || !useAuthStore().getFullUser.user_data?.hubspot_id) {
      return { name: 'forbidden' };
    }
  },
  children: [
    {
      path: 'subscription',
      name: 'ambassador-subscription',
      meta: {
        title: 'ambassador.landing.meta.title',
        permissions: ['recruiter_r']
      },
      component: () => import('@/views/recruiter/ambassador/AmbassadorLandingView.vue'),
      beforeEnter: () => {
        if (useLocaleStore().getCurrentISO !== 'fr-FR' || !useAuthStore().getFullUser.user_data?.hubspot_id) {
          return { name: 'forbidden' };
        }
        if (useAuthStore().getFullUser.user_data?.is_ambassador) {
          return { name: 'ambassador-portal' };
        }
      }
    },
    {
      path: 'portal',
      name: 'ambassador-portal',
      meta: {
        title: 'ambassador.dashboard.meta.title',
        permissions: ['recruiter_r']
      },
      component: () => import('@/views/recruiter/ambassador/AmbassadorDashboardView.vue'),
      beforeEnter: () => {
        if (useLocaleStore().getCurrentISO !== 'fr-FR' || !useAuthStore().getFullUser.user_data?.hubspot_id) {
          return { name: 'forbidden' };
        }
        if (!useAuthStore().getFullUser.user_data?.is_ambassador) {
          return { name: 'ambassador-subscription' };
        }
      }
    }
  ]
};
